import { render, staticRenderFns } from "./DefaultTextArea.vue?vue&type=template&id=76844372&scoped=true"
import script from "./DefaultTextArea.vue?vue&type=script&lang=js"
export * from "./DefaultTextArea.vue?vue&type=script&lang=js"
import style0 from "./DefaultTextArea.vue?vue&type=style&index=0&id=76844372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76844372",
  null
  
)

export default component.exports